// load users
export const LOAD_USERS = "bonfire/users/LOAD_USERS";
export const LOAD_USERS_SUCCESS = "bonfire/users/LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAIL = "bonfire/users/LOAD_USERS_FAIL";

// ADDING new user
export const ADD_USER_REQUEST = "bonfire/users/ADD_USER_REQUEST";
export const ADD_USER = "bonfire/users/ADD_USER";
export const ADD_USER_SUCCESS = "bonfire/users/ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "bonfire/users/ADD_USER_FAIL";

// save user changes
export const SAVE_USER_REQUEST = "bonfire/users/SAVE_USER_REQUEST";
export const SAVE_USER = "bonfire/users/SAVE_USER";
export const SAVE_USER_SUCCESS = "bonfire/users/SAVE_USER_SUCCESS";
export const SAVE_USER_FAIL = "bonfire/users/SAVE_USER_FAIL";

// GUI CONTROL
export const ADDING_USER = "bonfire/users/ADDING_USER";
export const VIEWING_USER = "bonfire/users/VIEWING_USER";
export const EDITING_USER = "bonfire/users/EDITING_USER";
export const END_ACTION = "bonfire/users/END_ACTION";
export const EDITING_USER_FORM = "bonfire/users/EDITING_USER_FORM";
export const VALIDATE_FORM_ERROR = "bonfire/users/VALIDATE_FORM_ERROR";

// Deactivate User
export const TOGGLE_DEACTIVATE = "bonfire/users/TOGGLE_DEACTIVATE";
export const TOGGLE_DEACTIVATE_SUCCESS =
  "bonfire/users/TOGGLE_DEACTIVATE_SUCCESS";
export const TOGGLE_DEACTIVATE_FAIL = "bonfire/users/TOGGLE_DEACTIVATE_FAIL";
